import * as tslib_1 from "tslib";
import { OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { TagEvent } from 'src/app/shared/models/dali-tags.model';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { ProductsService } from 'src/app/shared/services/products/products.service';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { OpEnum } from '../../../shared/enums/op.enum';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';
import { ProductsBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { ConfigurationService } from 'src/app/shared/services/configuration/configuration.service';
/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
var SelectedProductDetailComponent = /** @class */ (function () {
    /**
     * Summary      Constructor of the component.
     *
     * @param {CopyService}        copyService        Injectable copyService service.
     * @param {NavigationService}  navigationService  Injectable navigationService service.
     * @param {AbreCuentasService} abreCuentasService Injectable abreCuentasService service.
     * @param {ParametersService}  parametersService  Injectable parametersService service.
     * @param {BioCatchService}    bioCatchService    Injectable bioCatchService service.
     * @param {DomSanitizer}       _sanitizer         Injectable _sanitizer service.
     * @param {ProductsService}    productsService    Injectable productsService service.
     */
    function SelectedProductDetailComponent(copyService, helper, navigationService, abreCuentasService, parametersService, bioCatchService, _sanitizer, productsService, headerService, taggingService, channelCommunicatorService, bitacoraService, requestService, configurationService) {
        this.copyService = copyService;
        this.helper = helper;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.bioCatchService = bioCatchService;
        this._sanitizer = _sanitizer;
        this.productsService = productsService;
        this.headerService = headerService;
        this.taggingService = taggingService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.bitacoraService = bitacoraService;
        this.requestService = requestService;
        this.configurationService = configurationService;
        /**
         * Define el estado por defecto para mostrar el modal
         *
         * *Sets modal default state to show modal*
         *
         * @access public
         * @type {boolean}
         */
        this.showModal = false;
        /**
         * Define el título para las pestañas de los componentes
         *
         * *Sets modal default state to show modal*
         *
         * @access public
         * @type {string[]}
         */
        this.listTabs = [];
        /**
         * Define la variable benefitList como una arreglo donde se registrará la lista de beneficios del producto
         *
         * *Sets benefitList variable as empty array where product benefits will be registered*
         *
         * @access public
         * @type {any}
         */
        this.benefitList = [];
        /**
         * Define la variable principalCharacteristics como una arreglo donde se registrará las principales caracteristicas del producto
         *
         * *Sets principalCharacteristics variable as empty array where product main characteristics list will be registered*
         *
         * @access public
         * @type {any}
         */
        this.principalCharacteristics = [];
        /**
         * Define la variable transactionalBenefits como una arreglo donde se registrará los beneficios de las transacciones del producto
         *
         * *Sets transactionalBenefits variable as empty array where product transational benefits will be registered*
         *
         * @access public
         * @type {any}
         */
        this.transactionalBenefits = [];
        /**
         * Define la variable requirements como una arreglo donde se registrará la lista de requisitos del producto
         *
         * *Sets requirements variable as empty array where product requiremetns will be registered*
         *
         * @access public
         * @type {any}
         */
        this.requirements = [];
        /**
         * Define la variable ip como una Array
         *
         * *Defines ip variable as array*
         *
         * @access public
         * @type {Array}
         */
        this.ip = Array;
        /**
         * Define el título por defecto del header
         *
         * *Sets default header title*
         *
         * @access public
         * @type {string}
         */
        this.headerTitle = 'headerTitle';
        this.consultation_request = 'ConsultationRequest';
        this.headerService.show(false, false, true);
    }
    /**
     * Carga la información para el formulario y las pestañas
     *
     * *Summary charge data for form and tabs*
     */
    // ngOnInit() {
    //   const isEvidente = this.bioCatchService.isEvidenteCase();
    //   // const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    //   console.warn('product',this.abreCuentasService.getproductSelected());
    //   // this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
    //   this.listTabs = [
    //     this.copyService.copies.product_detail_tab1,
    //     this.copyService.copies.product_detail_tab2,
    //     this.copyService.copies.product_detail_tab3,
    //     this.copyService.copies.product_detail_tab4,
    //   ];
    //   this.currentTab = 1;
    //   this.productSelected = this.abreCuentasService.getproductSelected();
    //   console.log('productSelected',this.productSelected);
    //   this.productsDetail = this.productSelected.detail_product;
    //   this.vtu = this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_DETAIL_VTU)[this.productSelected.flow];
    //   if (this.channelCommunicatorService.getChannelId() === '163') {
    //     // tslint:disable-next-line:no-shadowed-variable
    //     const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    //     console.log('product',product);
    //     this.loadCopies();
    //     setTimeout(() => {
    //       this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
    //     }, 1000);
    //   } else {
    //     // tslint:disable-next-line:no-shadowed-variable
    //     const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    //     this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
    //     this.productSelected = this.abreCuentasService.getproductSelected();
    //     this.productsDetail = this.productSelected.detail_product;
    //     this.vtu = this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_DETAIL_VTU)[this.productSelected.flow];
    //     if (this.productsDetail.costs) {
    //       this.tableHeaderFields = this.productsDetail.costs.table.title.map(e => e.key);
    //     }
    //   }
    //   if (this.productsDetail.costs) {
    //     this.tableHeaderFields = this.productsDetail.costs.table.title.map(e => e.key);
    //   }
    // }
    SelectedProductDetailComponent.prototype.ngOnInit = function () {
        if (this.parametersService.getParameter('warningDisplay') &&
            (this.channelCommunicatorService.getChannelId() === '141' ||
                this.channelCommunicatorService.getChannelId() === '163' ||
                this.channelCommunicatorService.getChannelId() === '131' ||
                this.channelCommunicatorService.getChannelId() === '160')) {
            this.navigationService.navigateToGeneralInformation('999');
        }
        var isEvidente = this.bioCatchService.isEvidenteCase();
        // const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
        // this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
        this.listTabs = [
            this.copyService.copies.product_detail_tab1,
            this.copyService.copies.product_detail_tab2,
            this.copyService.copies.product_detail_tab3,
            this.copyService.copies.product_detail_tab4,
        ];
        this.currentTab = 1;
        // tslint:disable-next-line:early-exit
        if (this.channelCommunicatorService.getChannelId() === '163') {
            // const allyName = this.abreCuentasService.getproductSelected().es;
            var product = this.abreCuentasService.getproductSelected().product_code;
            this.loadCopies();
            setTimeout(function () {
                // this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
            }, 1000);
        }
        else {
            // tslint:disable-next-line:no-shadowed-variable
            var product = this.abreCuentasService.getproductSelected().product_code;
            // this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, false, isEvidente);
            this.productSelected = this.abreCuentasService.getproductSelected();
            this.productsDetail = this.productSelected.detail_product;
            this.vtu = this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_DETAIL_VTU)[this.productSelected.flow];
            if (this.productsDetail.costs) {
                this.tableHeaderFields = this.productsDetail.costs.table.title.map(function (e) { return e.key; });
            }
        }
    };
    SelectedProductDetailComponent.prototype.loadCopies = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ally;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.channel = this.channelCommunicatorService.getChannelId();
                        return [4 /*yield*/, this.requestService.documentsAllies()
                                .then(function (res) { return _this.allies = res.Ally; })
                                .catch(function (err) { return console.log(err); })];
                    case 1:
                        _a.sent();
                        ally = this.allies.filter(function (item) { return item.code_Ally === _this.abreCuentasService.getAllyCode(); });
                        this.productSelected = ally[0];
                        this.productsDetail = this.productSelected.detail_product;
                        this.imageLink1 = ally[0].banner[0].value;
                        this.imageLink2 = ally[0].banner[1].value;
                        this.imageLink3 = ally[0].banner[2].value;
                        this.imageLink4 = ally[0].banner[3].value;
                        this.vtu = this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_DETAIL_VTU)[this.productSelected.flow];
                        if (this.productsDetail.costs) {
                            this.tableHeaderFields = this.productsDetail.costs.table.title.map(function (e) { return e.key; });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Siguiente paso
     *
     * *Summary Next Step*
     */
    SelectedProductDetailComponent.prototype.next = function () {
        var _this = this;
        if (this.abreCuentasService.getAllyCode()) {
            this.configurationService.getRatesByAllies(this.abreCuentasService.getAllyCode())
                .then(function (response) {
                console.log(response.data);
                _this.abreCuentasService.setRateAlly(response.data);
                console.log(_this.abreCuentasService.getRateAlly().rates);
                // console.warn('---->TASAS', this.configurationService.getRatesByAllies());
            }).catch(function (err) { return console.log('errConfig', err); });
        }
        this.productsService.getAgreementsOffers().then(function (response) {
            _this.navigationService.nextStep(response);
        }, function () {
            _this.navigationService.navigateToGeneralInformation('500');
        }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
    };
    /**
     * Pestaña seleccionada
     *
     * *Summary Selected Tab*
     *
     * @param event
     */
    SelectedProductDetailComponent.prototype.onClickTab = function (event) {
        this.currentTab = event.current;
        this.pageTagEvent(event.selected);
    };
    /**
     * Muestra el modal de VTU
     *
     * *Summary Show Modal VTU*
     */
    SelectedProductDetailComponent.prototype.showModalVTU = function () {
        console.log('showModalVTU', this.productSelected.product_type, BUSINESS_CONST.PRODUCT_TYPE_TC);
        // in analist
        this.openLink(this.productSelected.detail_product.characteristics.vtu_text.link);
        // if (this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
        //  const endpoint = this.productSelected.detail_product.characteristics.vtu_text.link;
        //  this.openLink(endpoint);
        // } else {
        //  document.body.classList.add('no-scroll');
        //  // Se agregó el tag pv123, aunque hay que validar el tag para tarjeta de crédito
        //  this.navigationService.pageLoadTag(false, ['pv224', 'pv120', 'pv80', 'pv123']);
        //  this.showModal = true;
        // }
    };
    /**
     * Cierra el modal de VTU y envia el tag de las carácteristicas
     *
     * *Summary close vtu modal and send the tag of characteristics*
     */
    SelectedProductDetailComponent.prototype.closeModalVTU = function () {
        document.body.classList.remove('no-scroll');
        this.showModal = false;
    };
    /**
     * Valida la seguridad de la aplicación a nivel de webview por medio del servicio BioCatch
     *
     * *Check app security at webview level by BioCatch service*
     */
    SelectedProductDetailComponent.prototype.checkBioCatch = function () {
        var _this = this;
        if (this.productSelected.name === 'ConsultationRequest') {
            this.taggEvent('10', this.copyService.copies.controls_return_button_soli.action2);
        }
        else {
            this.taggEvent('10', this.copyService.copies.controls_return_button.action2);
        }
        this.abreCuentasService.showGenericLoading();
        if (this.productSelected.name !== 'ConsultationRequest') {
            this.bioCatchService.checkCountry(false).then(function (response) {
                _this.abreCuentasService.hideGenericLoading();
                if (response.data.response) {
                    _this.next();
                }
                else {
                    _this.navigationService.navigateToGeneralInformation('dsbException');
                }
            }, function (_) {
                _this.abreCuentasService.hideGenericLoading();
                _this.navigationService.navigateToGeneralInformation('500');
            }).catch(function () {
                _this.abreCuentasService.hideGenericLoading();
                _this.navigationService.navigateToGeneralInformation('500');
            });
        }
        else {
            this.abreCuentasService.hideGenericLoading();
            this.next();
        }
    };
    /**
     * Sanitiza el texto del detalle del producto en el html
     *
     * *Sanitize text when html from product detail*
     *
     * @param {string} text
     * @returns {string} with sanitized text
     * @memberof ProductDetailComponent
     */
    SelectedProductDetailComponent.prototype.sanitize = function (text) {
        return this._sanitizer.sanitize(SecurityContext.HTML, text);
    };
    /**
     * Servicio para enviar datos a Google analytics
     *
     * *Send data to Google Analytics*
     *
     * @param {string} eventLabel
     */
    SelectedProductDetailComponent.prototype.pageTagEvent = function (eventLabel) {
        var event = {
            category: {
                module: EVENT.customCategory.module.body,
                type: EVENT.customCategory.type.link,
                position: EVENT.customCategory.position.top,
            },
            action: EVENT.customAction.click,
            label: this.navigationService.camelize(eventLabel),
        };
        this.taggingService.pageTagEvent(event);
    };
    /**
     * Opens link to itau page
     *
     * @memberof SuccessPcoComponent
     */
    SelectedProductDetailComponent.prototype.openLink = function (link) {
        this.channelCommunicatorService.getImpl().openExternalBrowser(link, 5, true);
    };
    /**
     * Detect previus click
     */
    SelectedProductDetailComponent.prototype.previous = function () {
        this.taggEvent('10', this.copyService.copies.controls_return_button.action1);
    };
    /**
     * Send tagg event on buttons continue and return
     * @param tag_number
     * @param label
     * @returns
     */
    SelectedProductDetailComponent.prototype.taggEvent = function (tag_number, label) {
        var tagPageName = this.navigationService.getCurrentStep().tag_name;
        if (tagPageName !== 'pv458') {
            return;
        }
        try {
            var changes = this.taggingService.createTagChanges(tagPageName, tag_number);
            var event_1 = {
                category: {
                    module: EVENT.customCategory.module.body,
                    type: EVENT.customCategory.type.button,
                    position: EVENT.customCategory.position.center,
                },
                action: EVENT.customAction.click,
                label: label ? label : EVENT[tagPageName + "E" + tag_number + "customLabel"],
            };
            this.taggingService.pageTagEvent(event_1, changes);
        }
        catch (error) {
            console.log("Error en " + error);
        }
    };
    return SelectedProductDetailComponent;
}());
export { SelectedProductDetailComponent };
